module.exports = __webpack_public_path__ + "img/foot-logo.fa757aa5.png";